import { Paper, styled } from '@mui/material';

import UserCell from '../../../components/UserCell';
import { generateClasses } from '../../../utils/helper';

export const layoutClasses = {
  ...generateClasses('Layout', [
    'root',
    'acadlyLogo',
    'content',
    'contentHeader',
    'contentFooter',
    'title',
    'subtitle',
    'userCell',
    'avatar',
  ]),
};

export const Root = styled(Paper)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
  padding: theme.spacing(4, 2),
  paddingTop: theme.spacing(16),
  backgroundColor: 'transparent',
}));

export const StyledUserCell = styled(UserCell)(({ theme }) => ({
  backgroundColor: theme.palette.primary[50],
  borderRadius: 8,
  [`& .${layoutClasses.avatar}`]: {
    borderColor: theme.palette.primary[300],
  },
}));
